export const APP_VERSION = "2.6";
